import { notifyAdapter } from '@/features/messages/adapters/notify-adapter'
import { pbCustomerEnrichment } from './adapters/pb-customer-enrichment'
import { pbCustomers } from './adapters/pb-customers'
import { pbHistory } from '@/features/shared/adapters/pb-history'
import type { NotifyPort } from '@/features/messages/domain/notify'
import type { CustomerEnrichmentPort } from './domain/customer-enrichment'
import type { CustomerPort } from './domain/customer'
import type { HistoryPort } from '@/features/shared/domain/history'

const customers: CustomerPort = pbCustomers
const customerEnrichment: CustomerEnrichmentPort = pbCustomerEnrichment
const notify: NotifyPort = notifyAdapter
const history: HistoryPort = pbHistory

export { customers, customerEnrichment, notify, history }
